import { mergeActionDefinitions } from "../../../utils";

export default mergeActionDefinitions("ScormPackageAnalytics", {
  fetchAllUsers: ["courseId", "scormPackageId"],
  fetchCourseData: ["courseId"],
  fetchScormPackageData: ["scormPackageId"],
  fetchUsersAnalytics: ["courseId", "scormPackageId"],
  handleFetchAllUsersFailure: ["error"],
  handleFetchAllUsersSuccess: ["users"],
  handleFetchCourseDataFailure: ["error"],
  handleFetchCourseDataSuccess: ["course"],
  handleFetchScormPackageDataFailure: ["error"],
  handleFetchScormPackageDataSuccess: ["scormPackage"],
  handleFetchUsersAnalyticsFailure: ["error"],
  handleFetchUsersAnalyticsSuccess: ["usersAnalytics", "unitsAnalytics", "fetchScormPackagePartInstSummaryRollup"],
  mount: ["courseId", "scormPackageId"],
  unmount: ["courseId", "scormPackageId"],
});
